import React from 'react';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { MultiSelectProps } from './multi-select';
import { TransferList } from './transfer-list';

export function MultiSelectMany<T>(props: MultiSelectProps<T>) {
  const selectRef = React.useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const popoverKeyRef = React.useRef(0);

  const handleOpen = () => {
    setOpen(true);
    // Increment key to force TransferList to remount and reset state
    popoverKeyRef.current += 1;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const id = open ? 'multi-select-popover' : undefined;

  return (
    <Paper sx={{ display: 'flex' }}>
      <Stack>
        <InputLabel
          sx={{
            backgroundColor: '#ffffff',
            padding: '1px 4px',
            borderRadius: '4px',
          }}
          id="buildings-label"
        >
          Filter by {props.label} Name
        </InputLabel>
        <Select
          ref={selectRef}
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          value={props.selected.map((s) => props.itemValue(s))}
          renderValue={props.renderValue}
          displayEmpty
          sx={{ backgroundColor: 'white' }}
          MenuProps={{
            open: false, // Disable native menu
            onClose: handleClose,
          }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={selectRef.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          slotProps={{
            paper: {
              sx: {
                maxWidth: '600px',
                width: '94%',
              },
            },
          }}
          onClose={handleClose}
        >
          <TransferList<T>
            key={popoverKeyRef.current}
            {...props}
            onDone={props.onChange}
            onCancel={handleClose}
          />
        </Popover>
      </Stack>
    </Paper>
  );
}
